<template lang="pug">
.container-restricao
    div(
        v-if='restricoes.length > 0',
        :class='restricoes[index].inibido !== "undefined" && restricoes[index].inibido ? "camada-inibida" : ""',
        v-for='(restricao, index) in listaRestricoes'
    )
        slot(name='botaoInibir', :restricao='restricoes[index]')
        .card-restricao
            .container-restricao-acoes(
                v-if='habilitarZoomRestricao && (restricoes[index].geometry || restricoes[index].geometria || geometria)'
            )
                div
                    BaseButton(
                        size='small',
                        icon='mdi mdi-crosshairs-gps',
                        @click='aplicarZoomRestricao(index)'
                    )
            slot(name='selecionarRestricao', :restricao='restricoes[index]')
            p
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.tipoArea') }}:
                |
                | {{ restricao.tipo_area || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.dataTAD') }}:
                |
                | {{ restricao.dat_embargo || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.nomeDaPessoa') }}:
                |
                | {{ restricao.nome_embargado || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.numeroTAD') }}:
                |
                | {{ restricao.num_tad || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.areaHa') }}:
                |
                | {{ formatNumber(restricao.areaHa) }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.percentualDeSobreposicao') }}:
                |
                | {{ formatNumberPercent(restricao.percentualSobreposicaoGeometria) }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.documento') }}:
                |
                | {{ formatCpfCnpj(restricao.cpf_cnpj) }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.descricaoInfracao') }}:
                |
                | {{ restricao.des_infracao || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.descricaoTAD') }}:
                |
                | {{ restricao.des_tad || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.numeroAutoInfracao') }}:
                |
                | {{ restricao.num_auto_infracao || '-' }}
                Criticidade(
                    v-if='restricao.nivelAlerta',
                    :restricao='restricao'
                )
</template>

<script>
import Criticidade from '@/components/diagnosticoSocioambiental/Criticidade.vue';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';
import formatters from '@/utils/formatters';

export default {
    name: 'area-embargada-ibama-poligono-pamgia',

    components: {
        Criticidade,
        BaseButton
    },

    computed: {
        listaRestricoes: function () {
            return this.restricoes.map(value => {
                if (value.properties) {
                    return {
                        ...value.properties
                    };
                }
                return value;
            });
        }
    },

    methods: {
        aplicarZoomRestricao(index) {
            if (this.restricaoSelecionadaZoomIndex !== index) {
                this.restricaoSelecionadaZoomIndex = index;
                const geometria = this.geometria ? this.geometria[index] : null;
                this.$emit(
                    'aplicar-zoom-restricao',
                    this.restricoes[index],
                    geometria
                );
            } else {
                this.restricaoSelecionadaZoomIndex = '';
                this.$emit('aplicar-zoom-restricao', null, null);
            }
        },
        existeGeometria(restricao) {
            return !!(restricao.geometry || restricao.geometria);
        },
        formatNumber(number) {
            if (!number) return '-';
            return formatters.maxFormatNumber(number, 2);
        },
        formatNumberPercent(number) {
            if (!number) return '-';
            return formatters.maxFormatNumber(number, 2) + '%';
        },
        formatCpfCnpj(cpfCnpj) {
            if (!cpfCnpj) return '-';
            return formatters.numeralStringFormatToDocumento(formatters.removerPontuacaoDocumento(cpfCnpj));
        }
    },

    props: {
        restricoes: {
            type: Array,
            required: true
        },
        geometria: {
            type: Array,
            default: null
        },
        habilitarZoomRestricao: {
            type: Boolean,
            default: false
        }
    }
};
</script>
